import type {
  ApplicationStatus,
  RejectReasonCode,
  SalaryRange,
} from './types'

export const HOURS_IN_MONTH = 168

export const rejectOptions: { code: RejectReasonCode; label: string }[] = [
  { code: 'too_expensive', label: 'Rate too high' },
  { code: 'skills_gap', label: 'Skills gap' },
  { code: 'other', label: 'Other' },
]

export const statusBadgeClass: Record<ApplicationStatus, string> = {
  saved: 'bg-slate-100 dark:bg-slate-800/80 text-slate-700 dark:text-slate-300 border border-slate-300 dark:border-slate-700',
  applied: 'bg-slate-200 dark:bg-slate-800 text-slate-900 dark:text-slate-100 border border-slate-300 dark:border-slate-700',
  in_process: 'bg-sky-100 dark:bg-sky-900/60 text-sky-900 dark:text-sky-100 border border-sky-300 dark:border-sky-800',
  offer: 'bg-emerald-100 dark:bg-emerald-900/60 text-emerald-900 dark:text-emerald-100 border border-emerald-300 dark:border-emerald-800',
  rejected: 'bg-rose-100 dark:bg-rose-900/70 text-rose-900 dark:text-rose-100 border border-rose-300 dark:border-rose-800',
  hired: 'bg-emerald-100 dark:bg-emerald-800/70 text-emerald-900 dark:text-emerald-50 border border-emerald-300 dark:border-emerald-700',
  archived: 'bg-slate-200 dark:bg-slate-700/80 text-slate-900 dark:text-slate-100 border border-slate-300 dark:border-slate-600',
  ghosted: 'bg-orange-100 dark:bg-orange-900/60 text-orange-900 dark:text-orange-100 border border-orange-300 dark:border-orange-800',
  withdrawn: 'bg-slate-200 dark:bg-slate-700 text-slate-900 dark:text-slate-100 border border-slate-300 dark:border-slate-600',
  offer_declined: 'bg-amber-100 dark:bg-amber-900/60 text-amber-900 dark:text-amber-100 border border-amber-300 dark:border-amber-800',
  accepted: 'bg-emerald-100 dark:bg-emerald-800/70 text-emerald-900 dark:text-emerald-50 border border-emerald-300 dark:border-emerald-700',
}

export const formatSalary = (
  range: SalaryRange,
  expected: number | null,
  opts?: { autoConvertRates?: boolean },
) => {
  const autoConvertRates = opts?.autoConvertRates ?? true
  if (range) {
    const monthlyPart = `${range.min.toLocaleString('pl-PL')} - ${range.max.toLocaleString('pl-PL')} ${range.currency}`
    if (!autoConvertRates) return monthlyPart
    const hourlyMin = monthlyToHourly(range.min)
    const hourlyMax = monthlyToHourly(range.max)
    const hourlyPart =
      hourlyMin != null && hourlyMax != null
        ? `${hourlyMin.toLocaleString('pl-PL')} - ${hourlyMax.toLocaleString('pl-PL')} ${range.currency}/h`
        : null
    return hourlyPart ? `${monthlyPart} · ${hourlyPart}` : monthlyPart
  }
  if (expected) {
    return `${expected.toLocaleString('pl-PL')} (expected) PLN`
  }
  return '—'
}

export const monthlyToHourly = (monthly: number | null | undefined) =>
  monthly != null ? Math.round(monthly / HOURS_IN_MONTH) : null

export const hourlyToMonthly = (hourly: number | null | undefined) =>
  hourly != null ? Math.round(hourly * HOURS_IN_MONTH) : null

